import { DatePickerInput, PrimaryButton } from 'components';
import { validDate } from 'helpers';
import styles from '../headers.module.css';
import moment from 'moment';

export default function DateRangePicker({
	dateRange,
	setDateRange,
	onComplete,
}) {
	const checkComplete = (start, end) => {
		if (onComplete && validDate(start) && validDate(end) && start < end) {
			onComplete();
		}
	};

	const datePickerStyle = {
		width: '90%',
		marginTop: '5px',
		marginBottom: '5px',
		borderRadius: '15px',
	};

	return (
		<div className={styles.dateContainer}>
			<DatePickerInput
				className={datePickerStyle}
				label='Start Date'
				value={moment(dateRange[0])}
				name='Start Date'
				maxDate={
					validDate(moment(dateRange[1]))
						? new Date(moment(dateRange[1]))
						: null
				}
				onChange={(e) => {
					setDateRange([e, dateRange[1]]);
					checkComplete(e, dateRange[1]);
				}}
			/>
			<DatePickerInput
				label='End Date'
				className={datePickerStyle}
				value={moment(dateRange[1])}
				name='End Date'
				minDate={
					validDate(moment(dateRange[0]))
						? new Date(moment(dateRange[0]))
						: null
				}
				onChange={(e) => {
					setDateRange([dateRange[0], e]);
					checkComplete(dateRange[0], e);
				}}
			/>
			<div className={styles.clearButtonContainer}>
				<PrimaryButton
					onClick={() => {
						setDateRange([null, null]);
						onComplete();
					}}>
					Clear Dates
				</PrimaryButton>
			</div>
		</div>
	);
}
